import React from 'react';
import { Box, Grid, GridExtendedProps, useResponsive } from '@common-fe/common-fe';
import styled from 'styled-components';

const StyledDropWrapper = styled(Box)`
  @media ${({ theme }) => theme.deviceSize.lessThen.laptopL} {
    width: 100%;
  }
`;

interface Props extends GridExtendedProps {
  children: React.ReactNode;
  isSmallViewVersion?: boolean;
  isFlex?: boolean;
  isThumbsTopPosition?: boolean;
}

const DropWrapper: React.FC<Props> = ({ children, isSmallViewVersion, isFlex, isThumbsTopPosition, ...rest }) => {
  const { isMobile } = useResponsive();

  if (isMobile) {
    return <Box direction="column" align={isSmallViewVersion ? 'center' : undefined}>{children}</Box>;
  }

  if (isSmallViewVersion) {
    return (
      <StyledDropWrapper width={isFlex ? '100%' : '324px'} flex={{ grow: 1 }} direction="column-reverse">
        {children}
      </StyledDropWrapper>
    );
  }

  if (isThumbsTopPosition) {
    return <Box direction="column">{children}</Box>;
  }

  return (
    <Grid columns={['96px', 'auto']} height="453px" style={{ position: 'relative' }} {...rest}>
      {children}
    </Grid>
  );
};

export default DropWrapper;
